import React, { useEffect, useState } from "react";
import HeaderText from '../../components/HeaderText'
import Story from '../../components/Story'
import PageStep from '../../components/PageStep'
import { Row, Col } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import  { Redirect } from 'react-router-dom'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { Button, Modal } from 'react-bootstrap'
import {Helmet} from "react-helmet";

const TopicPage = props => {
    const { topicId } = useParams();

    const [redirectLink, setRedirectLink] = useState(null);
    const [alreadyLoaded, setAlreadyLoaded] = useState(false);
    const [hasAlert, setHasAlert] = useState(false);

    useEffect(() => {
        let hasOnlineActivity = false
        let currentActivityId = ''

        UserService.getActivities({
            'status': 'RUNNING',
            'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name ? AuthService.getCurrentUser().domain.name : '',
            'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id ? AuthService.getCurrentUser().room.id : '', 

        }).then((res) => {
            if (res.data.data.length > 0) {
                currentActivityId = res.data.data[0].id
                hasOnlineActivity = true
            }
        }).then((res) => {         
            if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'headmaster') {
                setRedirectLink('/report')
            } else if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'teacher' && hasOnlineActivity) {
                console.log('hasOnlineActivity');
                setHasAlert(true)
                setRedirectLink(`/activity/live/${currentActivityId}`)
            } else if (AuthService.getCurrentUser() && (AuthService.getUserRole() === 'teacher' || AuthService.getUserRole() === 'student')) {
                setRedirectLink(`/activity`)
            }
            setAlreadyLoaded(true)
        })
    }, [])

    const goto = () => {
        if (typeof window !== 'undefined') {
            window.location.href = redirectLink;
       }
       
    }
        if (alreadyLoaded && redirectLink) {
            if (hasAlert) {
                return (<Modal
                    show={hasAlert}
                    onHide={() => { setHasAlert(false); }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="alert-modal"
                >
                        <div>
                            <Modal.Header closeButton className="alert-header">
                            </Modal.Header>
                            <Modal.Body className="font-sarabun text-center pb-4 pt-0">
                                <p>ไม่สามารถ Back กลับได้ ต้องดำเนินกิจกรรมให้จบก่อน</p>
                                <Button className="bluebtn d-inline py-1 py-md-2 px-3 m-1 font-sarabun-bold border-radius-10" onClick={() => { goto(); }}>กลับกิจกรรม</Button>
                            </Modal.Body>
                        </div>
                </Modal>)
            }         
        }

        return (
            <div>
                <Helmet>
                    <title>รีวิวก่อนเริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวกประจำวัน  - Mindsetmaker.co</title>
                    <meta property="og:title"       content={`รีวิวก่อนเริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวกประจำวัน  - Mindsetmaker.co`} />
                    <meta property="og:description" content={`รีวิวก่อนเริ่มกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวกประจำวัน ประจำชั้น${AuthService.getCurrentUser().room.displayName} ${AuthService.getCurrentUser().domain.displayName}`} />
                </Helmet>
                <Row >
                    <Col className="header-text">
                        {/* <HeaderText cardImage="http://placehold.jp/286x180.png" text1="Homeroom" cardTitle="" text2="ห้อง ม.2/1  คุณครูสมหมาย ชายล้วน" /> */}
                        <HeaderText cardImage="http://placehold.jp/286x180.png" text1="Homeroom" cardTitle="" />
                    </Col>
                </Row>
                <Row className="bg-white">
                    <Col xs={12} className="main-detail mb-1 mt-md-3">
                        <PageStep step="2" />
                    </Col>
                </Row>
                <Row className="bg-white">
                    <Col xs={12} className="main-detail mb-3 mt-md-3">
                        <Story topicId={topicId} showQuestion="1" hideStart="0" />
                    </Col>
                </Row>
            </div>
        );
    

    
};


export default TopicPage;